export default __webpack_public_path__ + "static/media/ddsu5168-2.8ded3e6f.png";